import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { getHomeUrl as _ } from '../../utils/urls';
import {APARTMENTS, COMMERCIALS, GARAGES, LANDS, SALE, RENT} from '../../consts';
import {RESIDENTIAL_COMPLEX} from '../../utils/aliases';

function HomeSectionMenu (props) {
  const { dealType, realtyType } = props;
  return (
    <ul className='section-links list-inline'>
      <li>
        <Link
          exact
          to={_(SALE, APARTMENTS)}
          className='link'
          isActive={() =>  realtyType === APARTMENTS }
          >
            <span className='link-text'>Квартиры и комнаты</span>
        </Link>
      </li>
      <li>
        <a href={RESIDENTIAL_COMPLEX} className='link'>
          <span className='link-text'>Новостройки</span>
        </a>
      </li>
      <li>
        <Link
          to={_(SALE, LANDS)}
          className='link'
          isActive={() =>  realtyType === LANDS }
        >
          <span className='link-text'>Дома и участки</span>
        </Link>
      </li>
      <li>
        <Link
          to={_(SALE, COMMERCIALS)}
          className='link'
          isActive={() =>  realtyType === COMMERCIALS }
        >
          <span className='link-text'>Коммерческая</span>
        </Link>
      </li>
      <li>
        <Link 
          to={_(SALE, GARAGES)}
          className='link'
          isActive={() =>  realtyType === GARAGES }
        >
          <span className='link-text'>Гаражи</span>
        </Link>
      </li>
    </ul>
  );
}

HomeSectionMenu.propTypes = {};
HomeSectionMenu.defaultProps = {};

export default HomeSectionMenu;



// WEBPACK FOOTER //
// ./src/ui/Menu/HomeSectionMenu.jsx